import { ChevronLeft, ChevronRight } from "lucide-react";

import { addDays } from "@/core/format/format";

import { Button } from "./button";
import { cn } from "./cn";
import { inputClass } from "./field";

const isDay = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value);

/** One day: the day before / after, a date field, and back to today. `max` stops it in the future. */
export function DayPicker({
  date,
  today,
  max,
  onChange,
}: {
  date: string;
  today: string;
  max?: string;
  onChange: (day: string) => void;
}) {
  return (
    <div className="flex items-center gap-2 print:hidden">
      <Button
        variant="secondary"
        size="icon"
        aria-label="Day before"
        onClick={() => onChange(addDays(date, -1))}
      >
        <ChevronLeft aria-hidden="true" />
      </Button>
      <input
        type="date"
        aria-label="Day"
        value={date}
        max={max}
        onChange={(event) => isDay(event.target.value) && onChange(event.target.value)}
        className={cn(inputClass, "h-11 w-auto")}
      />
      <Button
        variant="secondary"
        size="icon"
        aria-label="Day after"
        disabled={max !== undefined && date >= max}
        onClick={() => onChange(addDays(date, 1))}
      >
        <ChevronRight aria-hidden="true" />
      </Button>
      {date !== today && (
        <Button variant="quiet" onClick={() => onChange(today)}>
          Today
        </Button>
      )}
    </div>
  );
}
